import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { resolveImg, fmt } from "@/lib/api";

export default function ProductCard({ p }) {
  const hasVariants = Array.isArray(p.variants) && p.variants.length > 1;
  const minPrice = hasVariants ? Math.min(...p.variants.map((v) => Number(v.price))) : Number(p.price);
  const totalStock = hasVariants
    ? p.variants.reduce((s, v) => s + Number(v.stock || 0), 0)
    : Number(p.stock);

  return (
    <Link
      to={`/product/${p.slug}`}
      data-testid={`product-card-${p.slug}`}
      className="product-card group block bg-slate-950/40 border border-white/5 relative"
    >
      <div className="aspect-[4/5] overflow-hidden bg-slate-900 relative">
        <img src={resolveImg(p.image_url)} alt={p.name} className="w-full h-full object-cover opacity-90 group-hover:opacity-100 group-hover:scale-105 transition-all duration-500" />
        <div className="absolute top-3 left-3 label-mono text-cyan-400 bg-slate-950/80 px-2 py-1 border border-cyan-500/20">
          {p.category}
        </div>
        {p.featured && (
          <div className="absolute top-3 right-3 label-mono text-slate-950 bg-cyan-400 px-2 py-1">Featured</div>
        )}
        <div className="absolute bottom-3 right-3 w-8 h-8 bg-cyan-500 text-slate-950 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
          <ArrowUpRight size={16} />
        </div>
      </div>

      <div className="p-5">
        <div className="flex items-start justify-between gap-4">
          <div>
            <div className="text-base font-medium tracking-tight">{p.name}</div>
            <div className="font-mono text-[10px] text-slate-500 mt-1 tracking-widest uppercase">
              {p.purity} · {p.molecular_weight || "—"}
            </div>
            {hasVariants && (
              <div className="font-mono text-[10px] text-slate-500 mt-1 uppercase tracking-widest" data-testid={`variant-count-${p.slug}`}>
                {p.variants.length} sizes available
              </div>
            )}
          </div>
          <div className="text-right">
            {hasVariants && <div className="font-mono text-[10px] text-slate-500 uppercase">from</div>}
            <div className="font-mono text-lg text-cyan-400" data-testid={`price-${p.slug}`}>{fmt(minPrice)}</div>
            <div className="label-mono text-slate-500 mt-1">{totalStock > 0 ? "In stock" : "Out"}</div>
          </div>
        </div>
        <p className="mt-3 text-xs text-slate-400 line-clamp-2 leading-relaxed">{p.short_description}</p>
      </div>
    </Link>
  );
}
